import { Badge } from '@agion/ui'
import type { DeploymentModel } from '@/core/infra_types'

interface DeploymentModelBadgeProps {
  model: DeploymentModel
}

const modelLabelMap: Record<DeploymentModel, string> = {
  vm_single: 'VM Single',
  vm_ha: 'VM HA',
  dc_ha: 'DC HA',
  k8s_edge: 'K8s Edge',
  k3s_bare: 'k3s Bare',
}

const modelVariantMap: Record<DeploymentModel, 'default' | 'info' | 'brand' | 'purple'> = {
  vm_single: 'default',
  vm_ha: 'info',
  dc_ha: 'brand',
  k8s_edge: 'purple',
  k3s_bare: 'info',
}

export function DeploymentModelBadge({ model }: DeploymentModelBadgeProps) {
  return (
    <Badge variant={modelVariantMap[model] ?? 'default'}>
      {modelLabelMap[model] ?? model}
    </Badge>
  )
}
